import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import './Navbar.css';
import Sidebar from './Sidebar';
import { useAdminInfo } from '../hooks/useAdminInfo';

const Path = (props) => (
  <motion.path
    fill="transparent"
    strokeWidth="3"
    strokeLinecap="round"
    {...props}
  />
);

const MenuToggle = ({ toggle, scrolled }) => (
  <button onClick={toggle} className="menu-toggle">
    <svg width="30" height="23" viewBox="0 0 23 23">
      <Path
        stroke={scrolled ? '#1f2937' : '#ffffff'}
        variants={{
          closed: { d: 'M 2 2.5 L 20 2.5' },
          open: { d: 'M 3 16.5 L 17 2.5' },
        }}
      />
      <Path
        stroke={scrolled ? '#1f2937' : '#ffffff'}
        d="M 2 9.423 L 20 9.423"
        variants={{
          closed: { opacity: 1 },
          open: { opacity: 0 },
        }}
        transition={{ duration: 0.1 }}
      />
      <Path
        stroke={scrolled ? '#1f2937' : '#ffffff'}
        variants={{
          closed: { d: 'M 2 16.346 L 20 16.346' },
          open: { d: 'M 3 2.5 L 17 16.346' },
        }}
      />
    </svg>
  </button>
);

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const { info } = useAdminInfo();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 30);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <nav className={`custom-navbar${scrolled ? ' scrolled' : ''}`}>
        <div className="custom-navbar-inner">
          <Link to="/" className="custom-navbar-logo-link">
            <div className="custom-navbar-logo">
          
                <img src="https://res.cloudinary.com/dpuo4ow5h/image/upload/v1758372063/pisikoloji_web/hep6j7kzjyq28gltfwj1.png" alt="Site Logosu" className="logo-image" />
             
            
            </div>
          </Link>
          <div className="custom-nav-links">
            <Link to="/">Home</Link>
            <Link to="/about">About Us</Link>
            <Link to="/services">Projects</Link>
            <Link to="/blogs">Blog</Link>
            <Link to="/be-our-partner">Be Our Partner</Link>
            <Link to="/contact">Contact</Link>
          </div>
          <motion.div
            initial={false}
            animate={isOpen ? 'open' : 'closed'}
            className="custom-navbar-sidebar"
          >
            <MenuToggle toggle={toggleSidebar} scrolled={scrolled} />
          </motion.div>
        </div>
      </nav>
      <Sidebar isOpen={isOpen} toggle={toggleSidebar} />
    </>
  );
};

export default Navbar;